import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/billing/vo/ApiResultVo.interface';
import type {RefundableAmountVo} from '../../common/shared/api/billing/vo/RefundableAmountVo.interface';

/**
 * 환불 가능 잔액 조회
 *
 * Origin: pageBillingApi.getRefundableAmount
 * API: GET /v1/credit_refund/refundable_amount
 */
export async function getBillingCreditRefundRefundableAmount(
  accountId: number,
  options?: FetcherOptions
): Promise<ApiResultVo & {data: RefundableAmountVo}> {
  const response = await axiosBffFetch(
    '/api/billing/v1/credit_refund/refundable_amount',
    {
      method: 'GET',
      params: {
        account_id: accountId,
      },
    },
    options
  );
  return response.data;
}
